/**
 * @generated SignedSource<<2cc1ed11766201293b5c9459d41ae663>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPlusArticleLinkHandlerArticle$data = {
  readonly entityId: string;
  readonly id: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformArticle">;
  readonly " $fragmentType": "hooksPlusArticleLinkHandlerArticle";
};
export type hooksPlusArticleLinkHandlerArticle$key = {
  readonly " $data"?: hooksPlusArticleLinkHandlerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPlusArticleLinkHandlerArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksPlusArticleLinkHandlerArticle"
};

(node as any).hash = "f732c76ff9a92b37003abd461a98fc13";

export default node;
